<template>
  <div>
    <ul :style="`min-height: ${minHeight}px;`">
      <Spin fix v-if="loading" />
      <template v-if="!!list.length">
        <li
          class="cell"
          :style="cellStyle"
          v-for="c in list"
          :key="c.ID"
          @click="handleToLink(c)"
        >
          <label class="icon"></label>
          <div class="text">{{ c.NEWSTITLE }}</div>
          <div class="date">{{ c.NEWSDATETIME }}</div>
        </li>
      </template>
      <template v-else>
        <div class="emptyTips">暂无数据</div>
      </template>
    </ul>
    <Page
      v-if="pageVisible && total > pageSize"
      class-name="pag"
      :total="total"
      show-sizer
      show-elevator
      :page-size="pageSize"
      :current="current"
      :simple="isMobile()"
      @on-change="handleChange"
      @on-page-size-change="handlePageSizeChange"
    />
  </div>
</template>

<script>
import { formatDate, isMobile } from '@libs/util'
export default {
  name: 'list',
  props: {
    type: {
      type: String,
      default: ''
    },
    minHeight: {
      type: Number,
      default: 0
    },
    api: {
      type: Function,
      default: () => {}
    },
    size: {
      type: Number,
      default: 10
    },
    pageVisible: {
      type: Boolean,
      default: true
    },
    cellStyle: {
      type: String,
      default: ''
    },
    automatic: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      current: 1,
      pageSize: 10,
      loading: false,
      list: [],
      total: 0,
      isMobile
    }
  },
  mounted () {
    this.pageSize = this.size
    this.automatic && this.getPage()
  },
  methods: {
    async getPage () {
      this.loading = true
      try {
        const query = {
          PageIndex: this.current,
          PageSize: this.pageSize,
          SUPPLY_TYPE: this.type
        }
        let { data: { list, total } } = await this.api(query)
        list.map(m => m.NEWSDATETIME = formatDate(m.NEWSDATETIME))
        this.list = list
        this.total = total
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handleChange (index) {
      this.current = index
      this.getPage()
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.getPage()
    },
    handleToLink (row) {
      const { type } = this
      this.$router.push({
        name: 'content',
        query: {
          type,
          id: row.ID
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
.cell {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background .2s ease-in-out;
  &:hover {
    background: #f3f3f3;
  }
  .icon {
    width: 12px;
    height: 12px;
    display: inline-block;
    vertical-align: middle;
    background: $default;
    border-radius: 100%;
    margin-right: 10px;
  }
  .text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 16px;
  }
  .date {
    font-size: 12px;
    color: #515a6e;
  }
}
.emptyTips {
  text-align: center;
  padding: 20px 0;
}
.pag {
  text-align: right;
  margin-top: 16px;
}
</style>
